
import { Component, Prop, Vue } from 'vue-property-decorator'

import { OrderResult } from '../types/dotationOrderForm'

@Component({ name: 'OrderSuccessDialog' })
export default class extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ required: true }) result!: OrderResult

  get dialogVisible(): boolean {
    return this.visible
  }

  set dialogVisible(value: boolean) {
    if (!value) this.$emit('close')
  }

  goToOrders(): void {
    this.$emit('close')
  }
}
